import { Component, ElementRef, Input } from '@angular/core';
var LoadingIndicatorComponent = /** @class */ (function () {
    /**
     * LoadingIndicator constructor
     * @param elementRef
     * @type ElementRef
     * @description Injects a reference to the rendered element in DOM
     *
     */
    function LoadingIndicatorComponent(elementRef) {
        this.elementRef = elementRef;
    }
    /**
     * Implementation of Angular's OnInit lifecyvle hook
     */
    LoadingIndicatorComponent.prototype.ngOnInit = function () { };
    LoadingIndicatorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'cov-loading-indicator',
                    template: "<div class=\"a-loading-indicator {{ modifier && 'a-loading-indicator--' + modifier || modifier }}\"\r\n\t data-t-name=\"LoadingIndicator\"\r\n\t [attr.data-t-decorator]=\"decorator\">\r\n\t<div class=\"a-loading-indicator__one\"></div>\r\n\t<div class=\"a-loading-indicator__two\"></div>\r\n\t<div class=\"a-loading-indicator__three\"></div>\r\n</div>\r\n"
                }] }
    ];
    /** @nocollapse */
    LoadingIndicatorComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    LoadingIndicatorComponent.propDecorators = {
        modifier: [{ type: Input }],
        decorator: [{ type: Input }]
    };
    return LoadingIndicatorComponent;
}());
export { LoadingIndicatorComponent };
//# sourceMappingURL=loading-indicator.component.js.map